export enum LOGIN_ROUTE_NAMES {
  LOGIN_PAGE = "login-page",
  LOGIN_CALLBACK = "login-callback",
}
